// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"
import PhotoSession from "./photo-session.js"
import PhotoSessionGroup from "./photo-session-group.js"

const modelClassData = {
  "attributes": {
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "initials": {
      "column": {
        "default": null,
        "name": "initials",
        "null": true,
        "type": "string"
      },
      "name": "initials",
      "selected_by_default": null,
      "translated": null
    },
    "kmd_serial_number": {
      "column": {
        "default": null,
        "name": "kmd_serial_number",
        "null": true,
        "type": "string"
      },
      "name": "kmd_serial_number",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_group_id": {
      "column": {
        "default": null,
        "name": "photo_session_group_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_session_group_id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_id": {
      "column": null,
      "name": "photo_session_id",
      "selected_by_default": null,
      "translated": null
    },
    "photos_count": {
      "column": {
        "default": 0,
        "name": "photos_count",
        "null": false,
        "type": "integer"
      },
      "name": "photos_count",
      "selected_by_default": null,
      "translated": null
    },
    "role": {
      "column": {
        "default": null,
        "name": "role",
        "null": false,
        "type": "string"
      },
      "name": "role",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "PhotoSessionGroupContact",
  "collectionKey": "photo_session_group_contacts",
  "collectionName": "photo_session_group_contacts",
  "i18nKey": "photo_session_group_contact",
  "camelizedLower": "photoSessionGroupContact",
  "name": "PhotoSessionGroupContact",
  "nameDasherized": "photo-session-group-contact",
  "pluralName": "photo_session_group_contacts",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "ContactPhotoSessionCurrent",
      "collectionName": "contact_photo_session_currents",
      "foreignKey": "photo_session_group_contact_id",
      "name": "contact_photo_session_currents",
      "macro": "has_many",
      "resource_name": "ContactPhotoSessionCurrent",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "photo_session_id",
      "name": "photo_session",
      "macro": "has_one",
      "resource_name": "PhotoSession",
      "through": "photo_session_group"
    },
    {
      "className": "PhotoSessionGroup",
      "collectionName": "photo_session_groups",
      "foreignKey": "photo_session_group_id",
      "name": "photo_session_group",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroup",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContactTokenContact",
      "collectionName": "photo_session_group_contact_token_contacts",
      "foreignKey": "photo_session_group_contact_token_id",
      "name": "photo_session_group_contact_token_contacts",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroupContactTokenContact",
      "through": "photo_session_group_contact_tokens"
    },
    {
      "className": "PhotoSessionGroupContactToken",
      "collectionName": "photo_session_group_contact_tokens",
      "foreignKey": "photo_session_group_contact_id",
      "name": "photo_session_group_contact_tokens",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroupContactToken",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "photo_session_group_contact_id",
      "name": "photo_sheet_product_order_lines",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_session_group_contact_id",
      "name": "photos",
      "macro": "has_many",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_session_group_contact_id",
      "name": "preferred_photo",
      "macro": "has_one",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "initials",
      "column": {
        "default": null,
        "name": "initials",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "kmd_serial_number",
      "column": {
        "default": null,
        "name": "kmd_serial_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "photo_session_group_id",
      "column": {
        "default": null,
        "name": "photo_session_group_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "photos_count",
      "column": {
        "default": 0,
        "name": "photos_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "role",
      "column": {
        "default": null,
        "name": "role",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "albums_for_user"
    },
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "PhotoSessionGroup",
      "collectionName": "photo_session_groups",
      "foreignKey": "photo_session_group_id",
      "name": "photo_session_group",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroup",
      "through": null
    },
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "photo_session_id",
      "name": "photo_session",
      "macro": "has_one",
      "resource_name": "PhotoSession",
      "through": "photo_session_group"
    }
  ],
  "paramKey": "photo_session_group_contact",
  "primaryKey": "id"
}

/** Frontend model for PhotoSessionGroupContact. */
export default class PhotoSessionGroupContact extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  initials() {
    return this.readAttributeUnderscore("initials")
  }

  /** @returns {boolean} */
  hasInitials() {
    const value = this.initials()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  kmdSerialNumber() {
    return this.readAttributeUnderscore("kmd_serial_number")
  }

  /** @returns {boolean} */
  hasKmdSerialNumber() {
    const value = this.kmdSerialNumber()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoSessionGroupId() {
    return this.readAttributeUnderscore("photo_session_group_id")
  }

  /** @returns {boolean} */
  hasPhotoSessionGroupId() {
    const value = this.photoSessionGroupId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  photoSessionId() {
    return this.readAttributeUnderscore("photo_session_id")
  }

  /** @returns {boolean} */
  hasPhotoSessionId() {
    const value = this.photoSessionId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  photosCount() {
    return this.readAttributeUnderscore("photos_count")
  }

  /** @returns {boolean} */
  hasPhotosCount() {
    const value = this.photosCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  role() {
    return this.readAttributeUnderscore("role")
  }

  /** @returns {boolean} */
  hasRole() {
    const value = this.role()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  generateZipFile(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "generate_zip_file",
        primaryKey: this.primaryKey(),
        collectionName: "photo_session_group_contacts",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  moveToPhotoSessionGroup(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "move_to_photo_session_group",
        primaryKey: this.primaryKey(),
        collectionName: "photo_session_group_contacts",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./photo-session-group.js").default | null} */
  photoSessionGroup() {
    return this._readBelongsToReflection({modelClass: PhotoSessionGroup, reflectionName: "photo_session_group"})
  }

  /** @returns {Promise<import("./photo-session-group.js").default | null>} */
  loadPhotoSessionGroup() {
    if (!("photoSessionGroupId" in this)) throw new Error("Foreign key method wasn't defined: photoSessionGroupId")

    const id = this.photoSessionGroupId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_session_group",
        model: this,
        modelClass: PhotoSessionGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-session-group.js").default | null>} */
  ensurePhotoSessionGroupLoaded() {
    return this.ensureAssociationLoaded("photo_session_group")
  }

  /** @returns {import("./photo-session.js").default | null} */
  photoSession() {
    return this._readHasOneReflection({modelClass: PhotoSession, reflectionName: "photo_session"})
  }

  /** @returns {Promise<import("./photo-session.js").default | null>} */
  loadPhotoSession() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "photo_session",
        model: this,
        modelClass: PhotoSession
      },
      {
        params: {
          through: {
            model: "PhotoSessionGroupContact",
            id,
            reflection: "photo_session"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./photo-session.js").default | null>} */
  ensurePhotoSessionLoaded() {
    return this.ensureAssociationLoaded("photo_session")
  }
}
